// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-detail {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.recipe-detail-image {
  width: 100%;
  max-height: 500px;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.recipe-detail-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recipe-detail-content {
  background: var(--secondary-bg);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.recipe-detail-header {
  margin-bottom: 2rem;
}

.recipe-detail-title {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--primary-text);
}

.recipe-detail-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
  color: var(--secondary-text);
}

.recipe-detail-date {
  font-size: 0.9rem;
}

.recipe-detail-categories {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.recipe-detail-category {
  background: var(--accent-color);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
}

.recipe-detail-body {
  line-height: 1.6;
  color: var(--secondary-text);
}

.recipe-detail-body p {
  margin-bottom: 1rem;
}

.recipe-detail-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1rem 0;
}

.recipe-detail-footer {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.recipe-detail-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.recipe-detail-tag {
  background: var(--secondary-bg);
  color: var(--accent-color);
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  border: 1px solid var(--accent-color);
}

.recipe-detail-loading,
.recipe-detail-error,
.recipe-detail-not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-size: 1.2rem;
  color: var(--secondary-text);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--secondary-bg);
  border-top-color: var(--accent-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .recipe-detail {
    padding: 1rem;
  }

  .recipe-detail-title {
    font-size: 2rem;
  }

  .recipe-detail-meta {
    flex-direction: column;
    align-items: flex-start;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/RecipeDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".recipe-detail {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.recipe-detail-image {\n  width: 100%;\n  max-height: 500px;\n  overflow: hidden;\n  border-radius: 8px;\n  margin-bottom: 2rem;\n}\n\n.recipe-detail-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.recipe-detail-content {\n  background: var(--secondary-bg);\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.recipe-detail-header {\n  margin-bottom: 2rem;\n}\n\n.recipe-detail-title {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  color: var(--primary-text);\n}\n\n.recipe-detail-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  color: var(--secondary-text);\n}\n\n.recipe-detail-date {\n  font-size: 0.9rem;\n}\n\n.recipe-detail-categories {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.recipe-detail-category {\n  background: var(--accent-color);\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n}\n\n.recipe-detail-body {\n  line-height: 1.6;\n  color: var(--secondary-text);\n}\n\n.recipe-detail-body p {\n  margin-bottom: 1rem;\n}\n\n.recipe-detail-body img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n\n.recipe-detail-footer {\n  margin-top: 2rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.recipe-detail-tags {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.recipe-detail-tag {\n  background: var(--secondary-bg);\n  color: var(--accent-color);\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  border: 1px solid var(--accent-color);\n}\n\n.recipe-detail-loading,\n.recipe-detail-error,\n.recipe-detail-not-found {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-size: 1.2rem;\n  color: var(--secondary-text);\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--secondary-bg);\n  border-top-color: var(--accent-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .recipe-detail {\n    padding: 1rem;\n  }\n\n  .recipe-detail-title {\n    font-size: 2rem;\n  }\n\n  .recipe-detail-meta {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
